<template>
  <div>
    <TopNav />
    <!-- MAIN CONTENT
    ================================================== -->
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'Home'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <!--
              <div class="col-12 col-lg-6">
                <router-link :to="{ name: 'IncompleteCompletion' }" :class="this.$store.state.app.incomplete_completion ? '' : 'disabled'">
                  <div class="card card-fill-lg">
                    <div class="card-body text-center">
                      <i class="fe fe-paperclip"></i>
                      <h2 class="mb-3">
                        Eksik Tamamlama <sup class="badge badge-danger" v-if="!this.$store.state.app.incomplete_completion">Yakında</sup>
                      </h2>
                      <p class="card-text text-muted">
                        Bu bölümde okulda yapılan deneme sınavlarında yanlış cevapladığın ya da boş bıraktığın soruların kazanımlarına göre hazırlanan içerikleri bulabilirsin. 
                        Eksiklerini tamamlamak için önce <strong>Konu Anlatım</strong> videosunu sonra <strong>Soru Çözüm</strong> videosunu izle, sonra <strong>Küçük Sınav</strong> tüm soruları doğru cevaplandırmaya çalış. 
                        Tüm soruları doğru cevaplayana kadar Küçük Sınavı tekrarlayabilirsin.
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              -->
              
              <div class="col-12">
                <router-link :to="{ name: 'HomeWork' }" :class="this.$store.state.app.home_work ? '' : 'disabled'">
                  <div class="card card-fill-lg">
                    <div class="card-body text-center">
                      <i class="fe fe-edit-2"></i>
                      <h2 class="mb-3">
                        Online Sınav <sup class="badge badge-danger" v-if="!this.$store.state.app.home_work">Yakında</sup>
                      </h2>
                      <p class="card-text text-muted">
                        Bu bölümde senin için oluşturulmuş sınavları görebilir, belirlenen tarih/saat aralığında ve belirlenen süre içerisinde soruları yanıtlayabilirsin. 
                        Soruları çözerken üzerine yazım, işaretleme ya da çizim yapabilirsin. Sınav için belirlenen tarih/saat dolduğunda sonucunu ve cevaplarını görebilirsin. 
                        Unutma, bu sınav süresi içerisinde sadece bir kez yapabileceğin bir sınavdır. Süreni iyi kullan.
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav'
import Head from '@/components/Head'
import base from '@/mixins/base'
export default {
  name: 'Home',
  components: { TopNav, Head },
  mixins: [ base ],
  data() {
    return {
      student: {},
    }
  },
  computed: {
    studentName() {
      return this.student.AD + ' ' + this.student.SOYAD
    },
    studentOnlyName() {
      return this.student.AD
    },
    schoolInfo() {
      return this.student.OKUL + ' - ' + this.student.SINIF + '/' + this.student.SUBE
    }
  },
  created() {
    this.deviceTimeNConnectionCheck()
    this.student = JSON.parse(localStorage.getItem('student'))
  }
}
</script>
<style scoped>
.col-12 a.disabled .card {
  pointer-events: none;
  opacity: 0.6;
}
.card-body i.fe {
  font-size: 45px;
  color: #000;
}

.card-body h2 {
  color: #000;
}

.card:hover {
  background: #222222;
  color: #fff
}

.card {
  transition: 0.1s ease-out;
  border-color: transparent
}

.card:hover {
  background: #222222;
  box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.37);
}

.card:hover,
.card:hover i.fe,
.card:hover h2,
.card:hover .text-muted {
  color: #fff !important;
}
</style>